import React from "react";
import { LiaSave } from "react-icons/lia";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { message } from "antd";
import { PiPhonePlusBold } from "react-icons/pi";
import { TbMailShare } from "react-icons/tb";
import { BsTelephoneForwardFill } from "react-icons/bs";
import { IoMdMail } from "react-icons/io";
import { PostSupportData } from "../../Api/Support/Support";
import { toast } from "react-toastify";

export default function Support() {
  const validationSchema = Yup.object().shape({
    username: Yup.string()
    .transform((value) => value.trimStart())
    .matches(/^[A-Za-z\s]+$/, "Only letters  are allowed")
    .min(3, "Minimum 3 characters only")
    .max(20, "Maximum 20 characters only")
    .required("Name is required"),
    phone: Yup.string()
      .trim()
      .test("starts-with", "Phone number must start with 6, 7, 8 or 9", (val) => /^[6-9]/.test(val || ""))
      .matches(/^\d+$/, "Phone number must contain only numbers")
      .length(10, "Phone number must be 10 digits")
      .required("Phone number is required"),
    mail: Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email address format"
    )
    .required("Email is required"),
    message: Yup.string()
    .required("Message is required")
    .max(100,"Maximum 100 characters only"),
  });

  const handleSubmit = (values) => {
    console.log(values);
    const responce = PostSupportData(values)
    toast.success(responce)
    message.success("Form submitted successfully!");
  };

  return (
    <Formik
      initialValues={{
        username: "",
        phone: "",
        mail: "",
        message: "",
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
        resetForm();
        setSubmitting(false);
      }}
    >
      {({ isSubmitting,values,handleChange }) => (
        <div className=" ">
          <Form>
            <div className="bg-gray-200 p-[2vw] md:p-[1vw] rounded-[0.8vw]" >
            <div className="flex justify-center text-[#1f487c] text-[3.5vw] md:text-[1.7vw] font-bold mb-[1.3vw]">
              <h1>Get In Touch</h1>
            </div>

            <div className="mt-[1vw] mb-[vw] justify-center flex flex-col gap-y-[1vw] text-[#1f487c] text-base">
              {/* <div className="mb-2">
              <strong>Phone:</strong> <span>1234567890</span>
            </div>
            <div>
              <strong>Mail:</strong> <span>nubiznez@nubiznez.com</span>
            </div> */}
              <div className="flex justify-start items-center font-semibold gap-x-[1.3vw]">
                <div className="text-[2.5vw] md:text-[1.3vw]">
                  {/* <PiPhonePlusBold /> */}
                  <BsTelephoneForwardFill />
                </div>
                <div className="text-[2.5vw] md:text-[1vw]">+91 95666 77702</div>
              </div>
              <div className="flex justify-start items-center font-semibold gap-x-[1.3vw]">
                <div className="text-[2.5vw] md:text-[1.3vw]">
                  {/* <TbMailShare /> */}
                  <IoMdMail />
                </div>
                <div className="text-[2.5vw] md:text-[1vw]">info@thebusstand.com</div>
              </div>
            </div>

            <div className=" ">
              <div>
                {/* <label
                htmlFor="name"
                className="block mb-1 font-bold text-[#1f487c] text-base"
              >
                Name
              </label> */}
              <div className="relative">
                <Field
                  id="name"
                  name="username"
                  type="text"
                  placeholder="Name" 
                   onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue
                              .replace(/^\s+/, "") 
                              .replace(/\s{2,}/g, " ") 
                              .replace(/[^A-Za-z ]/g, ""); 
                          handleChange({
                           target: { name: e.target.name, value: cleanedValue },
                            });
              }}      
                  className="input-field mt-[1.5vw] text-[2.5vw] md:text-[1vw] w-[97%] h-[5vw] md:h-[2.5vw] pl-[1vw] text-[#1f487c] placeholder-gray-400 text-top 
            focus:outline-none focus:border-2 border-gray-300 px-[.5vw] py-[.5vw] rounded-sm md:rounded-md"
                  
                />
                <ErrorMessage
                  name="username"
                  component="div"
                  className="text-red-500 absolute bottom-[-2.5vw] md:bottom-[-1.2vw] left-[1vw] md:left-[.3vw] text-[2vw] md:text-[.8vw] font-semibold md:font-normal"
                />
                </div>

                {/* <label
                htmlFor="phone"
                className="block mb-1 font-bold text-[#1f487c] text-base"
              >
                Phone
              </label> */}
              <div className="relative">
                <Field
                  id="phone"
                  name="phone"
                  type="text"
                  placeholder="Phone"
                 onChange={(e) => {
                  let inputValue = e.target.value;
                  inputValue = inputValue.replace(/\s+/g, "");
                handleChange({
                  target: { name: e.target.name, value: inputValue },
                });
              }} 
                  className="input-field mt-[2.5vw] md:mt-[1.5vw] w-[97%] text-[2.5vw] md:text-[1vw] h-[5vw] md:h-[2.5vw] text-[#1f487c] pl-[1vw] placeholder-gray-400 text-top  
            focus:outline-none focus:border-2 border-gray-300  px-[.5vw] py-[.5vw] rounded-sm md:rounded-md"
                />
                <ErrorMessage
                  name="phone"
                  component="div"
                  className="text-red-500 absolute bottom-[-2.5vw] md:bottom-[-1.2vw] left-[1vw] md:left-[.3vw] text-[2vw] md:text-[.8vw] font-semibold md:font-normal"
                />
                </div>

                {/* <label
                htmlFor="mail"
                className="block mb-1 font-bold text-[#1f487c] text-base"
              >
                E-Mail
              </label> */}
              <div className="relative">
                <Field
                  id="mail"
                  name="mail"
                  type="text"
                  placeholder="Email"
                 onChange={(e) => {
                  let inputValue = e.target.value;
                  inputValue = inputValue.replace(/\s+/g, "");
                handleChange({
                  target: { name: e.target.name, value: inputValue },
                });
                  }} 
                  className="input-field mt-[2.5vw] md:mt-[1.5vw] w-[97%] text-[2.5vw] md:text-[1vw] h-[5vw] md:h-[2.5vw] text-[#1f487c] pl-[1vw] placeholder-gray-400 text-top  
            focus:outline-none focus:border-2 border-gray-300  px-[.5vw] py-[.5vw] rounded-sm md:rounded-md"
                />
                <ErrorMessage
                  name="mail"
                  component="div"
                  className="text-red-500 absolute bottom-[-2.5vw] md:bottom-[-1.2vw] left-[1vw] md:left-[.3vw] text-[2vw] md:text-[.8vw] font-semibold md:font-normal"
                />
                </div>

                {/* <label
                htmlFor="message"
                className="block mb-1 font-bold text-[#1f487c] text-base"
              >
                Message
              </label> */}
              <div className="relative">
                <Field
                style={{resize:"none"}}
                  id="message"
                  name="message"
                  as="textarea"
                  placeholder="Enter your message here..."
                   onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue
                              .replace(/^\s+/, "") 
                              .replace(/\s{2,}/g, " ") 
                              .replace(/[^A-Za-z ]/g, ""); 
                          handleChange({
                           target: { name: e.target.name, value: cleanedValue },
                            });
              }}
                  className="input-field mt-[2.5vw] md:mt-[1.5vw] w-[97%] h-[10vw] md:h-[5vw] text-[2.5vw] md:text-[1vw] text-[#1f487c] pl-[1vw] placeholder-gray-400 text-top  
            focus:outline-none focus:border-2 border-gray-300 px-[.5vw] py-[.5vw] rounded-sm md:rounded-md"
                />
                <ErrorMessage
                  name="message"
                  component="div"
                  className="text-red-500 absolute bottom-[-1vw] md:bottom-[-.8vw] left-[1vw] md:left-[.3vw] text-[2vw] md:text-[.8vw] font-semibold md:font-normal"
                />
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <button
                className="flex h-[5.5vw] md:h-[3vw] w-full me-1 md:me-2 bg-[#1F4B7F] mt-[1vw] px-[0.8vw] gap-[0.5vw] py-[0.3vw] rounded-sm md:rounded-[0.6vw] items-center justify-center"
                type="submit"
                //disabled={isSubmitting} // Disable button while submitting
              >
                <span>
                  <LiaSave color="white" className="text-[3.5vw] md:text-[1.5vw]"/>
                </span>
                <span className="text-white text-[2.5vw] md:text-[1vw]">Submit</span>
              </button>
            </div>
         </div> </Form>
        </div>
      )}
    </Formik>
  );
}
